const customTabs = {
    props: {     
        active:{
            type: Number,
            default: 0
        },
        items: {
            type: Array,
            default(){
                return []
            }
        },
        disabled: { // set disabled tabs with value 1 or enabled with value 0
            type: Array,
            default(){
                return []
            }
        },
        top: { // tabs to be top instead of bottom from horz line
            type: Boolean,
            default: false
        },
        wrapTextOnMultiple: {
            default: 0
        },
        hideNav: { // hide nav if true
            type: Boolean,
            default: false
        },
        miniTabClass: {
            type: String,
            default: ''
        }
    },
    template: 
    `<div class="b-tabs" :class="[topClass, hideNavClass, miniTabClass]">
        <ul v-if="!hideNav" class="b-tabs__nav" :class="[manyTabs, wrapTabClass]">
            <li v-for="( item, index ) in items" :class="activeClass(index)">
                <button class="b-tabs__lnk ui-tabs-anchor" @click="changeTab(index)" type="button" :disabled="isDisabled(index)">
                    <slot :item="item" :index="index"></slot>
                </button>
            </li>
        </ul>
        <transition-group name="fade-tab" mode="out-in">
            <slot name="tab-content" :items="items" :selected="selected" :changeTab="changeTab" :activeClass="activeClass" :isDisabled="isDisabled"></slot>    
        </transition-group>    
    </div>`,
    data: function () {
		return {
            selected: this.active
        }
    },
    mounted(){

        api.fn.getSvgSource()        

        this.changeTab(this.active)
    },
    methods:{
        changeTab(index){
            this.selected = index
            this.$emit("tabChanged", index, this.items[index])
        },
        isOpened(index){
            return this.selected === index
        },
        activeClass(index){ 
            if(this.selected === index && this.items.length > 1){
                return 'ui-tabs-active'
            }
            return ''
        },
        isDisabled(index){
            if(this.disabled[index] && this.disabled[index]>0){
                return true
            }
            return false
        }
    },
    computed:{
        manyTabs(){
            if(this.items.length>2){
                return  'b-tabs__nav--multiple'
            } else if (this.items.length === 1) {
                return 'b-tabs__nav--single'
            }
            return ''
        },
        topClass(){
            if(this.top)
                return 'b-tabs--top'

            return ''
        },
        wrapTabClass(){
            if(this.wrapTextOnMultiple && this.wrapTextOnMultiple >= this.items.length){
                return 'b-tabs__nav--wrap-text'
            }
        },
        hideNavClass(){
            if(this.hideNav && this.items.length<2) return 'b-tabs--hide-nav'
            return ''
        }
    },
    watch: {
        active(newVal) {
            this.changeTab(newVal)
        }
    },
}
